var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.333,
    height: 16,
    viewBox: "0 0 13.333 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file",
    transform: "translate(-42.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9813",
    "data-name": "Trac\\xE9 9813",
    d: "M54.939,2.7,53.345,1.087A3.692,3.692,0,0,0,50.738,0H46.333a3.671,3.671,0,0,0-3.667,3.667v8.667A3.671,3.671,0,0,0,46.333,16h6A3.671,3.671,0,0,0,56,12.333V5.278A3.643,3.643,0,0,0,54.939,2.7ZM54,12.333A1.667,1.667,0,0,1,52.333,14h-6a1.667,1.667,0,0,1-1.667-1.667V3.667A1.667,1.667,0,0,1,46.333,2H50V4.667A1.333,1.333,0,0,0,51.333,6H54Z",
    fill: "#b5b5b5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.31b45d45a78cac05f39eca7140e66b5f.svg";
export { ForwardRef as ReactComponent };